<template>
  <div>
    <v-expansion-panels>
      <v-expansion-panel v-for="(instruction,i) in instructions"
                         :key="i">
        <v-expansion-panel-header>
          {{ instruction.name }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text class="font-weight-medium text-center" v-html="instruction.content"/>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  export default {
    name: 'InstallInstructions',

    data() {
      return {
        instructions: [
          {
            name: 'Desktop',
            content:
                  '1.Use Chrome(or any browser that supports PWA\'s).<br>2.There should be an install icon on the address bar, click it.<br>OR<br>1. Click on the options icon(three dot column icon) in the top right of the browser.<br>2. Find the \'Install Scale Heaven\' and Click it.',
          },
          {
            name: 'Android',
            content:
                  'Install scale heaven from the play store - <a href="https://play.google.com/store/apps/details?id=com.scales.scaleheaven&hl=en" target="_blank" rel="noreferrer noopener">Click Here</a>',//<br> OR<br>In chrome, You can install by pressing the \'add scale-heaven to home screen\' when navigating to the website.<br>Or press options[in the top right] -> Add to home screen.',
          },
          {
            name: 'IOS',
            content:
                  '1. Open to <a href="http://music-guru.musitelligence.com" target="_blank" rel="noreferrer noopener">Scale Heaven</a> using Safari browser.<br>2. click Share.<br>3. Click Add to home screen.<br>That\'s it!<br>[PWA features work only for IOS 11.3 and above.]',
          },
        ],
      }
    },
  }
</script>


